import React from "react";
import { Box } from "@mui/material";
import {
  MISS_GENERATION_BACKGROUND_OPACITY,
  MISS_GENERATION_DETAIL_BG_POSITION,
  MISS_GENERATION_DETAIL_SURFACE,
  MISS_GENERATION_PODIUM_BG_POSITION,
} from "../../../utils/missGenerationCompetition";

export const PODIUM_DARK_SCRIM = `
  radial-gradient(ellipse at 50% -10%, rgba(239,54,78,0.28) 0%, transparent 42%),
  radial-gradient(ellipse at 18% 80%, rgba(240,199,94,0.12) 0%, transparent 45%),
  radial-gradient(ellipse at 82% 75%, rgba(232,196,168,0.1) 0%, transparent 40%),
  linear-gradient(180deg, #1e1520 0%, #14161f 48%, #0e1018 100%)
`;

/**
 * Detail hero: off-white + damask at low opacity.
 * darkWatermark: casting-call on dark podium stage.
 */
export default function MissGenerationBackgroundOverlay({
  imageUrl,
  variant = "light",
  opacity = MISS_GENERATION_BACKGROUND_OPACITY,
  backgroundPosition,
}) {
  if (!imageUrl) return null;

  const position =
    backgroundPosition ??
    (variant === "darkWatermark"
      ? MISS_GENERATION_PODIUM_BG_POSITION
      : MISS_GENERATION_DETAIL_BG_POSITION);

  if (variant === "darkWatermark") {
    return (
      <Box
        aria-hidden
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${imageUrl})`,
          backgroundSize: "cover",
          backgroundPosition: position,
          backgroundRepeat: "no-repeat",
          opacity,
          mixBlendMode: "screen",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />
    );
  }

  return (
    <>
      <Box
        aria-hidden
        sx={{
          position: "absolute",
          inset: 0,
          bgcolor: MISS_GENERATION_DETAIL_SURFACE,
          pointerEvents: "none",
          zIndex: 0,
        }}
      />
      <Box
        aria-hidden
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${imageUrl})`,
          backgroundSize: "cover",
          backgroundPosition: position,
          backgroundRepeat: "no-repeat",
          opacity,
          pointerEvents: "none",
          zIndex: 0,
        }}
      />
    </>
  );
}
